import { useState, useEffect } from 'react'
import s from './AdditionalFilters.scss'
import { FaAngleDown } from 'react-icons/fa'
import { IoIosFunnel } from 'react-icons/io'
import { makeGetRequest } from 'utils/api'
import { useImmer } from 'use-immer'
import { toCategories, toTeams } from './serializers'
import { Container, Row, Col } from 'reactstrap'
import { KeyValuePairs, Checkbox, OutsideClickContainer } from 'components/ideal-core-ui'
import Select from 'react-select'
import {
  fromConstantPropertyToSelectOptions,
  fromConstantPropertyToSelectValue
} from 'utils/serializers'
import { APP_CONSTANTS } from 'utils/constants'
import { Pills } from './Pills'

const initialState = {
  categories: [],
  sources: [],
  geographicalAreas: [],
  contractTypes: [],
  workTypes: [],
  priorities: [],
  scopes: [],
  sizes: []
}

const AdditionalFilters = ({
  additionalFilters,
  filters,
  changeAdditionalFilters,
  isFilteredByAdditionalFilters
}) => {
  const [showFilters, setShowFilters] = useState(false)
  const [state, setState] = useImmer(initialState)

  const isFiltered = isFilteredByAdditionalFilters()

  useEffect(() => {
    ;(async () => {
      const categories = await makeGetRequest('/v1/dealcategory')
      setState(draft => {
        draft.categories = toCategories(categories)
      })

      const sources = await makeGetRequest('/v1/dealsource')
      setState(draft => {
        draft.sources = toCategories(sources)
      })

      const geographicalAreas = await makeGetRequest('/v1/geographical-area')
      setState(draft => {
        draft.geographicalAreas = toCategories(geographicalAreas)
      })

      const contractTypes = await makeGetRequest('/v1/deal-contract-type')
      setState(draft => {
        draft.contractTypes = toCategories(contractTypes)
      })

      const scopes = await makeGetRequest('/v1/deal-scope')
      setState(draft => {
        draft.scopes = toCategories(scopes)
      })

      const workTypes = await makeGetRequest('/v1/deal-work-type')
      setState(draft => {
        draft.workTypes = toCategories(workTypes)
      })
      const teams = await makeGetRequest('/v1/teams')
      setState(draft => {
        draft.teams = toTeams(teams)
      })
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className={s.container}>
      <div className={s.additionalFilters} onClick={() => setShowFilters(!showFilters)}>
        <IoIosFunnel
          className={s.filtersIcon}
          style={isFiltered ? { color: 'mediumseagreen' } : {}}
        />
        {isFiltered ? <Pills filters={filters} /> : 'Additional filters'}
        <div className={s.filtersArrowWrapper}>
          <FaAngleDown className={s.filtersArrow} />
        </div>
      </div>
      {showFilters && (
        <OutsideClickContainer
          styles={{ height: 'initial' }}
          closeComponent={() => setShowFilters(false)}
        >
          <div className={s.filtersWrapper}>
            <Container>
              <Row>
                <Col xs={12} md={6}>
                  <KeyValuePairs
                    pairs={[
                      additionalFilters?.hasCategory
                        ? {
                            key: 'Category',
                            keyClass: s.bold,
                            value: (
                              <Select
                                onChange={value => changeAdditionalFilters(value, 'categories')}
                                options={state.categories}
                                value={filters.categories}
                                isClearable
                                isMulti
                              />
                            )
                          }
                        : {},
                      additionalFilters?.hasContractType
                        ? {
                            key: 'Contract Type',
                            keyClass: s.bold,
                            value: (
                              <Select
                                onChange={value => changeAdditionalFilters(value, 'contractTypes')}
                                options={state.contractTypes}
                                value={filters.contractTypes}
                                isClearable
                                isMulti
                              />
                            )
                          }
                        : {},
                      additionalFilters?.hasSize
                        ? {
                            key: 'Size',
                            keyClass: s.bold,
                            value: (
                              <Select
                                value={fromConstantPropertyToSelectValue(filters.sizes, 'DealSize')}
                                onChange={value => changeAdditionalFilters(value, 'sizes')}
                                options={fromConstantPropertyToSelectOptions(
                                  Object.keys(APP_CONSTANTS.DealSize),
                                  'DealSize'
                                )}
                                isClearable
                                isMulti
                              />
                            )
                          }
                        : {},
                      additionalFilters?.hasPriority
                        ? {
                            key: 'Priority',
                            keyClass: s.bold,
                            value: (
                              <Select
                                value={fromConstantPropertyToSelectValue(
                                  filters.priorities,
                                  'DealPriority'
                                )}
                                onChange={value => changeAdditionalFilters(value, 'priorities')}
                                options={fromConstantPropertyToSelectOptions(
                                  Object.keys(APP_CONSTANTS.DealPriority),
                                  'DealPriority'
                                )}
                                isClearable
                                isMulti
                              />
                            )
                          }
                        : {},
                      additionalFilters?.hasGeographicalArea
                        ? {
                            key: 'Geo Area',
                            keyClass: s.bold,
                            value: (
                              <Select
                                value={filters.geographicalAreas}
                                onChange={value =>
                                  changeAdditionalFilters(value, 'geographicalAreas')
                                }
                                options={state.geographicalAreas}
                                isClearable
                                isMulti
                              />
                            )
                          }
                        : {}
                    ]}
                  />
                </Col>
                <Col xs={12} md={6}>
                  <KeyValuePairs
                    pairs={[
                      additionalFilters?.hasContractorAwarded
                        ? {
                            key: 'Awarded',
                            keyClass: s.bold,
                            value: (
                              <Checkbox
                                size="md"
                                isChecked={filters.awarded}
                                triggerCheckbox={value => {
                                  changeAdditionalFilters(value.target.checked, 'awarded')
                                }}
                              />
                            )
                          }
                        : {},
                      additionalFilters?.hasTeams
                        ? {
                            key: 'Teams',
                            keyClass: s.bold,
                            value: (
                              <Select
                                onChange={value => changeAdditionalFilters(value, 'teams')}
                                options={state.teams}
                                value={filters.teams}
                                isClearable
                                isMulti
                              />
                            )
                          }
                        : {},
                      additionalFilters?.hasSource
                        ? {
                            key: 'Source',
                            keyClass: s.bold,
                            value: (
                              <Select
                                onChange={value => changeAdditionalFilters(value, 'sources')}
                                options={state.sources}
                                value={filters.sources}
                                isClearable
                                isMulti
                              />
                            )
                          }
                        : {},
                      additionalFilters?.hasScope
                        ? {
                            key: 'Scope',
                            keyClass: s.bold,
                            value: (
                              <Select
                                onChange={value => changeAdditionalFilters(value, 'scopes')}
                                options={state.scopes}
                                value={filters.scopes}
                                isClearable
                                isMulti
                              />
                            )
                          }
                        : {},
                      additionalFilters?.hasWorkType
                        ? {
                            key: 'Work Type',
                            keyClass: s.bold,
                            value: (
                              <Select
                                onChange={value => changeAdditionalFilters(value, 'workTypes')}
                                options={state.workTypes}
                                value={filters.workTypes}
                                isClearable
                                isMulti
                              />
                            )
                          }
                        : {}
                    ]}
                  />
                </Col>
              </Row>
            </Container>
          </div>
        </OutsideClickContainer>
      )}
    </div>
  )
}

export default AdditionalFilters
